import React, { useEffect, useState } from "react";
import "../../User/styles/pages/catalogue.scss";
import Header from "../../User/layouts/Header";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination } from "swiper/modules";
import { Typography, Container, Button, Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import bulk from "../../User/assets/bulk-categories.svg";
import accessories from "../../User/assets/accessories-categories.svg";
import Catalogue from "../../User/components/Catalogue";
import CategoryCard from "../../User/components/CategoryCard";
import Aboutus from "../../User/components/Aboutus";
import Downloadapp from "../../User/components/Download_app";
import Footer from "../../User/layouts/Footer";
import about_image from "../assets/icons/about-image.svg";
import WhatsApp from "../../User/components/WhatsApp";
import instance from "../../Utils/api";
import { useNavigate } from "react-router-dom";
import Image from "../../Utils/getImage";
import about_image2 from "../assets/about-image1.svg";
import about_image3 from "../assets/about-image2.svg";

const AboutData = [
  {
    image: about_image2,
    name: "Shruthi K",
    About:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cursus nibh mauris, nec turpis orci lectus maecenas.",
  },
  {
    image: about_image3,
    name: "James Gordan",
    About:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cursus nibh mauris, nec turpis orci lectus maecenas.",
  },
  {
    image: about_image,
    name: "Hannah Schmitt",
    About:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cursus nibh mauris, nec turpis orci lectus maecenas. ",
  },
  {
    image: about_image2,
    name: "Halena",
    About:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cursus nibh mauris, nec turpis orci lectus maecenas. ",
  },
  {
    image: about_image3,
    name: "Gazana",
    About:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cursus nibh mauris, nec turpis orci lectus maecenas. ",
  },
  {
    image: about_image,
    name: "Rey",
    About:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cursus nibh mauris, nec turpis orci lectus maecenas. ",
  },
];

const Catalogues = () => {
  const [categories, setCategories] = useState();
  const [subcategories, setSubCategories] = useState();
  const [western, setWestern] = useState();
  const [wedding, setWedding] = useState();
  const [banners, setBanners] = useState();
  const [designs, setDesigns] = useState();
  const [reviews, setReviews] = useState([]);
  const size = 6;
  const recommendedSize = 5;
  const [mostOrdered, setMostOrdered] = useState();
  const [recommended, setRecommended] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [swiperKey, setSwiperKey] = useState(0);

  useEffect(() => {
    if (banners?.length) {
      setSwiperKey((prev) => prev + 1);
    }
  }, [banners])

  //fetch categories
  const getCategories = async () => {
    setLoading(true);
    try {
      const response = await instance.get("/Catalogue/getCategorys");
      setCategories(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  //fetch subcategories
  const getSubCategories = async () => {
    setLoading(true);
    try {
      const response = await instance.get("/Catalogue/getSubCategory");
      setSubCategories(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  //fetch outfits data
  const getoutfitsData = async (outfits) => {
    console.log(outfits, "outfits")
    const params = {
      subCategory: outfits,
    };
    try {
      const response = await instance.get(`/Catalogue/getDesignfilter`, { params });
      console.log(response)
      if (outfits === "Wedding") {
        setWedding(response?.data?.data);
      } else if (outfits === "Western") {
        setWestern(response?.data?.data);
      } else {
        setDesigns(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(wedding)
  console.log(western)

  //fetch banners
  const getBanners = async () => {
    try {
      const response = await instance.get("/Banner/getBanners");
      setBanners(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  //fetch mostoreders
  const getMostOrdered = async () => {
    try {
      const response = await instance.get(
        `/Common/mostOrderedDesigns?size=${size}`
      );
      setMostOrdered(response?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  //fetch recommended
  const getRecommended = async () => {
    try {
      const response = await instance.get(
        `/Common/recommendedDesigns?size=${recommendedSize}`
      );
      setRecommended(response?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const getReviews = async () => {
    try {
      const response = await instance.get('Review/Allreviews')
      setReviews(response.data.reviews)
    } catch (err) {
      console.log(err);

    }
  }

  useEffect(() => {
    getReviews()
  }, [])

  useEffect(() => {
    getRecommended();
    getMostOrdered();
    getCategories();
    getSubCategories();
    getoutfitsData("Western");
    getoutfitsData("Wedding");
    getoutfitsData();
    getBanners();
    getReviews();
  }, []);


  // console.log(banners)
  return (
    <React.Fragment>
      <Header />
      <section className="catalogue">
        {/* <Swiper
          key={swiperKey}
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          loop={true}
          pagination={{
            clickable: true,
          }}
        >
          {banners?.length > 0 ? (
            banners?.filter((data) => data?.status === true)
              .map((data, index) => (
                <SwiperSlide key={index}>
                  {data?.image ? (
                    <div className="Banner_images">
                      <Image src={data.image} alt={data?.name || "Banner"} width="100%" height={500} />
                    </div>
                  ) : (
                    <p>No image available</p>
                  )}
                </SwiperSlide>
              ))
          ) : (
            <p>No banners available</p>
          )}
        </Swiper> */}
      </section>
      <section className="catalogue-categories">
        <Container maxWidth="lg">
          {/* <div className="catalogue-title">
            <Typography variant="h4">Categories</Typography>
            <Button onClick={() => navigate("/Categories")}>View All</Button>
          </div> */}
          <Grid container spacing={2}>
            {loading === true
              ? // Display Skeletons while loading
              Array.from({ length: categories?.length }).map((_, index) => (
                <Grid item key={index} size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
                  <Skeleton variant="circular" width={144} height={144} />
                </Grid>
              ))
              : // Display categories once loading is complete
              categories?.filter((data) => data?.status === true)
                ?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                // ?.slice(0, 6)
                .map((data) => (
                  <Grid
                    item
                    key={data.id}
                    size={{ xs: 12, sm: 6, md: 3, lg: 2 }}
                  >
                    <div
                      className="catalogue-image"
                      onClick={() =>
                        navigate(
                          `/Categories?CategoryId=${data?._id}&Category=${data?.category}`
                        )
                      }
                    >
                      <Image
                        src={data.picture}
                        alt={data.category}
                        height={144}
                        width={144}
                      />
                      <Typography variant="h5">{data.category}</Typography>
                    </div>
                  </Grid>
                ))}
          </Grid>
        </Container>
      </section>
      {/* <section className="catalogue-categories">
        <Container maxWidth="lg">
          <div className="catalogue-title">
            <Typography variant="h4">Sub Categories</Typography>
            <Button onClick={() => navigate("/Categories")}>View All</Button>
          </div>
          <Grid container spacing={2}>
            {loading === true
              ? // Display Skeletons while loading
              Array.from({ length: 6 }).map((_, index) => (
                <Grid item key={index} size={{ xs: 12, sm: 6, md: 3, lg: 2 }}>
                  <Skeleton variant="circular" width={144} height={144} />
                </Grid>
              ))
              : // Display categories once loading is complete
              subcategories?.filter((data) => data?.status === true)
                ?.slice(0, 6)
                .map((data) => (
                  <Grid
                    item
                    key={data.id}
                    size={{ xs: 12, sm: 6, md: 3, lg: 2 }}
                  >
                    <div
                      className="catalogue-image"
                      onClick={() =>
                        navigate(
                          `/Categories?id=${data._id}&name=${data.subCategory}&designtype=true`
                        )
                      }
                    >
                      <Image
                        src={data.picture}
                        alt={data.subCategory}
                        height={144}
                        width={144}
                      />
                      <Typography variant="h5">{data.subCategory}</Typography>
                    </div>
                  </Grid>
                ))}
          </Grid>
        </Container>
      </section> */}
      <React.Fragment>
        <section className="catalogue-page">
          <Container maxWidth="xl">
            <div className="catalogue-title">
              <Typography variant="h4">Mostly ordered</Typography>
              <Button onClick={() => navigate("/Categories?name=mostOrdered")}>
                View all
              </Button>
            </div>
            <>
              <Catalogue data={mostOrdered} />
            </>
          </Container>
        </section>
      </React.Fragment>
      <section className="recommended-section">
        <Container maxWidth="xl">
          <div className="recommended-title">
            <Typography variant="h5">Recommended</Typography>
            <Button onClick={() => navigate("/Categories?name=recommended")}>view all</Button>
          </div>
          <div className="recommended-images">
            <Grid container spacing={2}>
              {recommended?.map((data, item) => (
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
                  <CategoryCard
                    image={data?.picture[0]}
                    title={data?.name}
                    onclick={() => {
                      navigate(`/product/${data?._id}`);
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </Container>
      </section>
      <section className="recommended-section">
        <Container maxWidth="xl">
          <div className="recommended-title">
            <Typography variant="h5">Western Outfits</Typography>
            <Button onClick={() => navigate("/Categories")}>view all</Button>
          </div>
          <div className="recommended-images">
            <Grid container spacing={2}>
              {western?.slice(0, 5).map((data, item) => (
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
                  <CategoryCard
                    image={data?.picture[0]}
                    title={
                      data?.name?.length === "20"
                        ? data?.name
                        : data?.name?.substring(0, 20)
                    }
                    onclick={() => {
                      navigate(`/product/${data?._id}`);
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </Container>
      </section>
      <section className="recommended-section">
        <Container maxWidth="xl">
          <div className="recommended-title">
            <Typography variant="h5">Wedding Outfits</Typography>
            <Button onClick={() => navigate("/Categories")}>view all</Button>
          </div>
          <div className="recommended-images">
            <Grid container spacing={2}>
              {wedding?.slice(0, 5).map((data, item) => (
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}>
                  <CategoryCard
                    image={data?.picture[0]}
                    title={
                      data?.name?.length === "20"
                        ? data?.name
                        : data?.name?.substring(0, 20)
                    }
                    onclick={() => {
                      navigate(`/product/${data?._id}`);
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </Container>
      </section>
      {/* <React.Fragment>
                <Designers data={DesignerData} />
            </React.Fragment> */}
      <React.Fragment>
        <Aboutus data={reviews} />
      </React.Fragment>
      <React.Fragment>
        <Downloadapp />
      </React.Fragment>
      <React.Fragment>
        <Footer />
      </React.Fragment>
      <WhatsApp />
    </React.Fragment>
  );
};

export default Catalogues;
